import { render, staticRenderFns } from "./BoardOutputs.vue?vue&type=template&id=0cb341ec&scoped=true&"
import script from "./BoardOutputs.vue?vue&type=script&lang=js&"
export * from "./BoardOutputs.vue?vue&type=script&lang=js&"
import style0 from "./BoardOutputs.vue?vue&type=style&index=0&id=0cb341ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb341ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
